module.exports = __webpack_public_path__ + "media/greaves3.6960cabb.webm";